import { PRODUCT_FLAG_ROWS, type ProductFlagFormValues } from '@/definitions/productFlags'

export interface FlagChangeSummary {
  /** Labels of product flags being switched on. */
  enabling: string[]
  /** Labels of product flags being switched off. */
  disabling: string[]
  /** The Twilio account SID is a value, not a switch, so it is reported apart. */
  accountSidChanged: boolean
}

/**
 * What a save would actually do, in the operator's words.
 *
 * Compares the stored values against the staged ones so the confirmation can name the
 * product flags rather than asking for a blind yes. A flag toggled and toggled back
 * appears in neither list, because nothing about it is changing.
 */
export const summarizeFlagChanges = (
  saved: ProductFlagFormValues,
  pending: ProductFlagFormValues
): FlagChangeSummary => {
  const enabling: string[] = []
  const disabling: string[] = []

  for (const row of PRODUCT_FLAG_ROWS) {
    if (saved[row.field] === pending[row.field]) {
      continue
    }
    if (pending[row.field]) {
      enabling.push(row.label)
    } else {
      disabling.push(row.label)
    }
  }

  return {
    enabling,
    disabling,
    accountSidChanged: saved.twilio_account_sid !== pending.twilio_account_sid,
  }
}
